import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";

const OptionSelectComponent = ({
  selectedOption,
  setSelectedOption,
  optionsList,
  disabled,
}) => {
  return (
    <Container>
      {optionsList.map((btn, index) => (
        <Optionelement
          key={index}
          onClick={!disabled ? () => setSelectedOption(btn.value) : () => {}}
          selected={selectedOption === btn.value}
        >
          <p>{btn.text}</p>
        </Optionelement>
      ))}
    </Container>
  );
};

export default OptionSelectComponent;

const Container = styled.div`
  display: flex;
  border-radius: 5px;
  min-height: 30px;
  width: fit-content;
  align-items: center;
  overflow: hidden;
  :first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  :last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;
const Optionelement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  background: ${(props) =>
    props.selected
      ? lightThemeColors.socialMediaPreviewCard.buttonBgSelected
      : lightThemeColors.background};
  cursor: pointer;
  border: 1px solid ${lightThemeColors.socialMediaPreviewCard.buttonBgSelected};
  min-width: 80px;

  /* Remove left border for all but the first option to avoid double borders */
  &:not(:first-child) {
    border-left: none;
  }

  p {
    color: ${lightThemeColors.primaryColor};
    font-size: 14px;
    font-weight: ${(props) => (props.selected ? "550" : "500")};
    line-height: 20px;
    text-align: left;
    opacity: ${(props) => (props.selected ? 1 : 0.3)};
  }
`;
